import { render, staticRenderFns } from "./DefaultSection.vue?vue&type=template&id=79398d24&scoped=true&"
import script from "./DefaultSection.vue?vue&type=script&lang=js&"
export * from "./DefaultSection.vue?vue&type=script&lang=js&"
import style0 from "./DefaultSection.vue?vue&type=style&index=0&id=79398d24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79398d24",
  null
  
)

export default component.exports